<template>
    <sonicu-button  bg-color="bg-red-600"
                    bg-color-hover="bg-red-500"
                    bg-color-active="bg-red-600"
                    bg-color-focus="bg-red-600"
                    text-color="text-white"
                    text-color-hover="text-white"
                    border-color="border-transparent"
                    border-color-hover="border-red-700"
                    border-color-active="border-red-700"
                    @click="$emit('click', $event)"
    >
        <slot></slot>
    </sonicu-button>

</template>

<script>

import SonicuButton from "@/components/elements/buttons/SonicuButton";

export default {
    name: "ButtonRedPrimary",
    mixins: [],
    emits: ['click'],
    components: {SonicuButton},
    props: {
        
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>